export default __webpack_public_path__ + "./images/sv.79ae1321.png";